import {
  AD_PREVIEW_CAROUSEL_INDEX_KEY,
  AD_TEXT,
  CALL_TO_ACTION,
  CALL_TO_ACTION_LEARN_MORE,
  CALL_TO_ACTION_OPTION,
  CAROUSEL_ITEMS,
  CAROUSEL_ITEMS_LENGTH,
  CLICK_THROUGH_LINK,
  CUSTOMIZED_MEDIA_OPTION,
  CUSTOMIZED_STORY_FILE,
  DESCRIPTION_ENTER,
  DESCRIPTION_OPTION,
  EXISTING_POST,
  FB_PAGE_CHOICE,
  FB_PAGE_OPTION,
  FB_PAGE_SELECT,
  FB_SPONSOR_PAGE_ID,
  FORMAT_EXISTING_POST,
  FORMAT_OPTION,
  HEADLINE_ENTER,
  HEADLINE_OPTION,
  INCLUDE_PARTNERSHIP_PAGE,
  initialCarouselItem,
  initialFileValues,
  initialMediaValues,
  initialStoriesItem,
  INSTAGRAM_ACCOUNT_SPONSOR_ID,
  LEAD_GEN_FORM,
  IS_CURRENT_MEDIA_CUSTOMIZED_WITH_STORY,
  IS_ITEM_FORM_OPENED,
  NAME,
  PIXEL_CHOICE,
  PRIMARY_TEXT_LIST,
  RECOMMENDED_URL_TAGS,
  STATUS,
  STORIES_ITEM_SELECTED_INDEX,
  STORIES_ITEMS,
  TEXT_ENTER,
  TEXT_OPTION,
  URL_TAGS,
  URL_TAGS_OPTION,
  HEADLINE_BLANK,
  NO_URL_TAGS
} from '../../fields'
import { MEDIA_FILE_OPTION, MEDIA_FILE_UPLOAD } from '../../../../ReusableFormFields/AdFileUpload/fields'
import { LEAD_GENERATION } from '../../../../../constants/campaigns'
import { PAGE_LIKES } from '../../../../../constants/reusableObjectives'
import { IS_QUARANTINE } from '../../../../reusableFields'

export const LEAD_GENERATION_LINK = 'fb.me'

export const getInitialValues = ({ formatOption, preselectedValues, lineItem, isInternalAdCreation }) => {
  if (formatOption === FORMAT_EXISTING_POST) {
    return {
      [NAME]: '',
      // FORMAT
      [FORMAT_OPTION]: formatOption,
      [IS_QUARANTINE]: isInternalAdCreation, // partners ads always in going to quarantine, rightholder may select it
      // FACEBOOK PAGE
      [FB_PAGE_OPTION]: FB_PAGE_SELECT,
      [FB_PAGE_CHOICE]: '',
      // URL_TAGS
      [URL_TAGS_OPTION]: RECOMMENDED_URL_TAGS,
      [URL_TAGS]: {},
      [PIXEL_CHOICE]: '',
      [EXISTING_POST]: '',
      [CLICK_THROUGH_LINK]: preselectedValues[CLICK_THROUGH_LINK] || 'https://',
      [CALL_TO_ACTION_OPTION]: CALL_TO_ACTION_LEARN_MORE,
      [CALL_TO_ACTION]: preselectedValues[CALL_TO_ACTION] || '',
      [STATUS]: 'paused'
    }
  } else {
    const lineItemFacebookPage = lineItem?.promoted_object?.page_id
    const facebookPage =
      // For lead generation lineItems we use lineItemFacebookPage
      lineItem?.objective === LEAD_GENERATION ? lineItemFacebookPage : ''

    const initialLink =
      lineItem.objective === LEAD_GENERATION
        ? `https://${LEAD_GENERATION_LINK}/`
        : preselectedValues[CLICK_THROUGH_LINK] || 'https://'

    return {
      // NAME
      [NAME]: '',
      // FORMAT
      [FORMAT_OPTION]: formatOption,
      [IS_QUARANTINE]: isInternalAdCreation, // partners ads always in going to quarantine, rightholder may select it
      // TEXT
      [TEXT_OPTION]: TEXT_ENTER,
      [AD_TEXT]: '',
      [PRIMARY_TEXT_LIST]: [{ text: '' }],
      // FILE
      [MEDIA_FILE_OPTION]: MEDIA_FILE_UPLOAD,
      ...initialFileValues,
      // MEDIA
      ...initialMediaValues,
      // CLICK TROUGH LINK
      [CLICK_THROUGH_LINK]: initialLink,
      // HEADLINE
      [HEADLINE_OPTION]:
        // We don't support headline for page likes objective
        lineItem.objective === PAGE_LIKES ? HEADLINE_BLANK : HEADLINE_ENTER,
      // DESCRIPTION
      [DESCRIPTION_OPTION]: DESCRIPTION_ENTER,
      // CALL-TO-ACTION
      [CALL_TO_ACTION_OPTION]: CALL_TO_ACTION_LEARN_MORE,
      [CALL_TO_ACTION]: preselectedValues[CALL_TO_ACTION] || '',
      // FACEBOOK PAGE
      [FB_PAGE_OPTION]: FB_PAGE_SELECT,
      [FB_PAGE_CHOICE]: facebookPage,
      // FACEBOOK SPONSOR PAGE
      [INCLUDE_PARTNERSHIP_PAGE]: false,
      [FB_SPONSOR_PAGE_ID]: '',
      [INSTAGRAM_ACCOUNT_SPONSOR_ID]: '',
      // CAROUSEL
      [AD_PREVIEW_CAROUSEL_INDEX_KEY]: 'adCreateForm',
      [CAROUSEL_ITEMS]: [
        {
          ...initialCarouselItem,
          ...(preselectedValues[CALL_TO_ACTION] && {
            [CALL_TO_ACTION]: preselectedValues[CALL_TO_ACTION]
          }),
          ...(preselectedValues[CLICK_THROUGH_LINK] && {
            [CLICK_THROUGH_LINK]: preselectedValues[CLICK_THROUGH_LINK]
          })
        }
      ],
      [CAROUSEL_ITEMS_LENGTH]: 1,
      // ITEM FORM
      [IS_ITEM_FORM_OPENED]: true,
      // STORIES
      [STORIES_ITEMS]: [
        {
          ...initialStoriesItem,
          ...(preselectedValues[CALL_TO_ACTION] && {
            [CALL_TO_ACTION]: preselectedValues[CALL_TO_ACTION]
          }),
          ...(preselectedValues[CLICK_THROUGH_LINK] && {
            [CLICK_THROUGH_LINK]: preselectedValues[CLICK_THROUGH_LINK]
          })
        }
      ],
      [STORIES_ITEM_SELECTED_INDEX]: 0,
      // URL_TAGS
      [URL_TAGS_OPTION]:
        lineItem.objective === PAGE_LIKES
          ? // we don't show url tags step for page likes objective, and don't need to add tags to payload
            NO_URL_TAGS
          : RECOMMENDED_URL_TAGS,
      [URL_TAGS]: {},
      [STATUS]: 'paused',
      // CUSTOMIZED_MEDIA
      [CUSTOMIZED_MEDIA_OPTION]: '',
      [IS_CURRENT_MEDIA_CUSTOMIZED_WITH_STORY]: false,
      // PIXEL_CHOICE
      [PIXEL_CHOICE]: '',
      [CUSTOMIZED_STORY_FILE]: {
        ...initialFileValues,
        [MEDIA_FILE_OPTION]: MEDIA_FILE_UPLOAD
      },
      [LEAD_GEN_FORM]: ''
    }
  }
}
